"use client";

import { ListPlus } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { AddToListSheet } from "@/components/recipes/AddToListSheet";
import { Button } from "@/components/ui/button";

interface AddToListButtonProps {
  recipeTitle: string;
  ingredientLines: string[];
  className?: string;
  onAuthGate?: () => boolean;
  showCount?: boolean;
}

export function AddToListButton({
  recipeTitle,
  ingredientLines,
  className,
  onAuthGate,
  showCount,
}: AddToListButtonProps) {
  const t = useTranslations("addToList");
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (open) setMounted(true);
  }, [open]);

  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={() => {
          if (onAuthGate && !onAuthGate()) return;
          setOpen(true);
        }}
        disabled={ingredientLines.length === 0}
        className={className}
      >
        <ListPlus className="size-4" aria-hidden />
        {showCount && ingredientLines.length > 0
          ? t("triggerLabelWithCount", { count: ingredientLines.length })
          : t("triggerLabel")}
      </Button>
      {mounted && (
        <AddToListSheet
          isOpen={open}
          onClose={() => setOpen(false)}
          recipeTitle={recipeTitle}
          ingredientLines={ingredientLines}
        />
      )}
    </>
  );
}
